import { NETWORK, STATIC_DOMAIN, PLAYNC_DOMAIN, PURPLE_SCHEME, PURPLE_SCHEME_TYPE } from "../common/const";
import { getEncodeUrl, checkHasParams } from '../common/url';

class PurpleUrl {
    constructor() {
    }

    goErrorPage(env) {
        const locale = window?.userData?.locale;
        const errorPageEnv = env === NETWORK.stage || env === NETWORK.live ? NETWORK.live : NETWORK.rc;
        location.href = `${STATIC_DOMAIN[errorPageEnv]}/purple/launcher/error.html?location=${locale}`;
    }

    // 퍼플 모바일앱(인앱) - 외부 브라우저로 이동
    goPurpleAppExternal(url) {
        if(!url) {
            return;
        }
        
        window.open(this.setPurpleAppScheme(PURPLE_SCHEME_TYPE.EXTERNAL, url), '_blank'); 
    }

    setPurpleAppScheme(type, url) {
        if(type === PURPLE_SCHEME_TYPE.EXTERNAL) {
            url = this.setUrlAddPurpleParam(url);
        }

        if(!!url && type in PURPLE_SCHEME) {
            const encodeUrl = getEncodeUrl(url);
            url = `${PURPLE_SCHEME[type]}${encodeUrl}`;
        }

        return url;
    }

    // 퍼플 모바일앱(인앱)일 때, 고객지원 url 뒤에 sdk=ncmtalk 파라미터 붙이기
    setCsUrlAddPurpleAppParam(url) {
        const { hasParam, hasParams } = checkHasParams(url);
        return `${url}${!hasParam ? '?' : '&'}sdk=ncmtalk`;
    }

    setUrlAddPurpleParam(url) {
        const { hasParam, hasParams } = checkHasParams(url);
        return `${url}${!hasParam ? '?' : '&'}from=purple`;
    };
}

export default new PurpleUrl();